import type { ImportERPWorkQueryKey } from './types';

export const getImportERPWorkQueryKey = (): ImportERPWorkQueryKey => [
  'quotes',
  'importHistoricalWork',
  'importERPWork',
];
